import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import {ReactComponent as InfoIcon} from '../../../assets/images/info-icon.svg';
import ArrTooltipWrapper from '../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import './IngestionAnalyticsHeader.scss';
import ArrButton from '../../common/arr-button/ArrButton';
import {ReactComponent as PlusIcon} from '../../../assets/images/add.svg';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {
  resetCustomIndexState,
  setTabValue,
} from '../../../redux/slice/createCustomIndexSlice';
import {INGESTION_ANALYTICS_TAB} from '../analyticsTabConstants';

const infoTooltipContentPath =
  'ingestions.ingestionAnalytics.infoDialogConntet.';
const IngestionAnalyticsHeader = () => {
  const {tabValue} = useSelector((state: RootState) => state.indexManagement);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateCustomIndex = () => {
    dispatch(resetCustomIndexState());
    dispatch(setTabValue(INGESTION_ANALYTICS_TAB.INDEX_MANAGEMENT));
    navigate('Indexing/CreateCustomIndex');
  };
  return (
    <Box className="view-user-header">
      <Box className="view-user-title">
        <Typography
          className="typo-text headline3_size view-user-title-text"
          tabIndex={0}
          data-testid={`ingetion-analytics-header-title`}
        >
          {t('ingestions.ingestionAnalytics.title')}
        </Typography>
        <ArrTooltipWrapper
          title={t('ingestions.ingestionAnalytics.title')}
          trigger={
            <InfoIcon
              fontSize="medium"
              className="view-user-info-icon"
              tabIndex={0}
            />
          }
          dialogClassName="ingestion-analytics-info-dialog"
        >
          {(
            t(infoTooltipContentPath + 'topContent', {
              returnObjects: true,
            }) as string[]
          ).map((item, index) => (
            <div data-testid={`ingestion-header-item-top-content-${index}`}>
              {index !== 0 && (
                <br data-testid={`ingetion-analytics-header-br`} />
              )}
              {index !== 0 && (
                <br data-testid={`ingetion-analytics-header-br-btn`} />
              )}
              {item}
            </div>
          ))}
          <ul data-testid={`ingetion-analytics-header-ul`}>
            {(
              t(infoTooltipContentPath + 'runOptionGuide', {
                returnObjects: true,
              }) as string[]
            ).map((item, index) => (
              <li
                key={item}
                data-testid={`ingetion-analytics-header-li-run-option-guide-${index}`}
              >
                {item}
              </li>
            ))}
          </ul>
          {t(infoTooltipContentPath + 'runFullAnalyticsCaption')}
          <ul data-testid={`ingetion-analytics-header-ul-full-analytics`}>
            {(
              t(infoTooltipContentPath + 'runFullAnalyticsPerformTask', {
                returnObjects: true,
              }) as string[]
            ).map((item, index) => (
              <li
                key={item}
                data-testid={`ingetion-analytics-header-li-full-analytics-${index}`}
              >
                {item}
              </li>
            ))}
          </ul>

          {t(infoTooltipContentPath + 'runFullAnalyticsWithClusterCaption')}
          <ul data-testid={`ingetion-analytics-header-ul-cluster-caption`}>
            {(
              t(infoTooltipContentPath + 'runFullAnalyticsWithClusterOption', {
                returnObjects: true,
              }) as string[]
            ).map((item, index) => (
              <li
                key={item}
                data-testid={`ingetion-analytics-header-li-cluster-caption-${index}`}
              >
                {item}
              </li>
            ))}
          </ul>

          {t(infoTooltipContentPath + 'statusCaption')}
          <br data-testid={`ingetion-analytics-header-br-button`} />
          <br data-testid={`ingetion-analytics-header-br-icon`} />
          {t(infoTooltipContentPath + 'onceESIndexingCompleted')}
          <br data-testid={`ingetion-analytics-header-br-link`} />
          <br data-testid={`ingetion-analytics-header-br-input`} />
          {t(infoTooltipContentPath + 'reindexOption')}
          <br data-testid={`ingetion-analytics-header-br-text`} />
          <br data-testid={`ingetion-analytics-header-br-container`} />
          <Typography
            className="typo-text subhead3_size skip-analytics-label"
            data-testid={`ingetion-analytics-header-skip-analytics`}
          >
            {t(infoTooltipContentPath + 'skipAnalytics')}
          </Typography>
          {(
            t(infoTooltipContentPath + 'skipAnalyticsContent', {
              returnObjects: true,
            }) as string[]
          ).map((item, index) => (
            <div data-testid={`item-skip-analytics-${index}`}>
              {index !== 0 && (
                <br
                  data-testid={`ingetion-analytics-header-skip-analytics-br1-${index}`}
                />
              )}
              {index !== 0 && (
                <br
                  data-testid={`ingetion-analytics-header-skip-analytics-br2-${index}`}
                />
              )}
              {item}
            </div>
          ))}
        </ArrTooltipWrapper>
      </Box>
      {tabValue === INGESTION_ANALYTICS_TAB.INDEX_MANAGEMENT && (
        <ArrButton
          endIcon={<PlusIcon className="plus-icon" />}
          variant="primary"
          size="small"
          onClick={navigateCustomIndex}
          className="next-button"
          dataTestId="ingetion-analytics-header-custom-index-button"
        >
          {t('indexManagement.customIndexButton')}
        </ArrButton>
      )}
    </Box>
  );
};

export default IngestionAnalyticsHeader;
